export const ACTIVE_HISTORICO_CONVERSA = "ACTIVE_HISTORICO_CONVERSA"
export const ACTIVE_MESSAGES = "ACTIVE_MESSAGE"
export const SET_OPTION_PAGINATE = "SET_OPTION_PAGINATE"
export const SET_NULL_HISTORIC = "SET_NULL_HISTORIC"